import { ResponsivePictureLayout } from '@news-mono/component-library'
import { TogglesReduxState } from '@news-mono/web-common'
import { layout } from '../../App.routing'

export const bestAustralianYarnSegment = (toggles: TogglesReduxState) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: 'best-australian-yarn-curation-segment',
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            verticalSpacing: 'lg',
            themeOverride: 'best-australian-yarn',
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        verticalSpacing: 'gridGap',
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        cardLayout: [
                            'the-west-hero-lgNoBorder',
                            'hero-support',
                            'hero-support',
                        ],
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: 'best-australian-yarn',
                            offset: 0,
                            pageSize: 3,
                        },
                    },
                }),
            ],
        },
    })
}
